const latexCommands = [
  // Document structure
  { label: '\\documentclass', type: 'keyword', detail: 'Document class', apply: '\\documentclass{}' },
  { label: '\\usepackage', type: 'keyword', detail: 'Import package', apply: '\\usepackage{}' },
  { label: '\\title', type: 'keyword', apply: '\\title{}' },
  { label: '\\author', type: 'keyword', apply: '\\author{}' },
  { label: '\\date', type: 'keyword', apply: '\\date{}' },
  { label: '\\maketitle', type: 'keyword' },
  { label: '\\tableofcontents', type: 'keyword' },
  { label: '\\newcommand', type: 'keyword', apply: '\\newcommand{}{}' },
  { label: '\\renewcommand', type: 'keyword', apply: '\\renewcommand{}{}' },
  { label: '\\input', type: 'keyword', apply: '\\input{}' },
  { label: '\\include', type: 'keyword', apply: '\\include{}' },

  // Sectioning
  { label: '\\part', type: 'keyword', apply: '\\part{}' },
  { label: '\\chapter', type: 'keyword', apply: '\\chapter{}' },
  { label: '\\section', type: 'keyword', apply: '\\section{}' },
  { label: '\\subsection', type: 'keyword', apply: '\\subsection{}' },
  { label: '\\subsubsection', type: 'keyword', apply: '\\subsubsection{}' },
  { label: '\\paragraph', type: 'keyword', apply: '\\paragraph{}' },

  // Text formatting
  { label: '\\textbf', type: 'function', detail: 'Bold', apply: '\\textbf{}' },
  { label: '\\textit', type: 'function', detail: 'Italic', apply: '\\textit{}' },
  { label: '\\texttt', type: 'function', detail: 'Monospace', apply: '\\texttt{}' },
  { label: '\\underline', type: 'function', detail: 'Underline', apply: '\\underline{}' },
  { label: '\\emph', type: 'function', detail: 'Emphasis', apply: '\\emph{}' },
  { label: '\\textsc', type: 'function', detail: 'Small caps', apply: '\\textsc{}' },
  { label: '\\textrm', type: 'function', detail: 'Roman', apply: '\\textrm{}' },
  { label: '\\textsf', type: 'function', detail: 'Sans-serif', apply: '\\textsf{}' },
  { label: '\\footnote', type: 'function', apply: '\\footnote{}' },

  // References and citations
  { label: '\\label', type: 'function', apply: '\\label{}' },
  { label: '\\ref', type: 'function', apply: '\\ref{}' },
  { label: '\\eqref', type: 'function', apply: '\\eqref{}' },
  { label: '\\pageref', type: 'function', apply: '\\pageref{}' },
  { label: '\\cite', type: 'function', apply: '\\cite{}' },
  { label: '\\citep', type: 'function', apply: '\\citep{}' },
  { label: '\\citet', type: 'function', apply: '\\citet{}' },
  { label: '\\bibliography', type: 'keyword', apply: '\\bibliography{}' },
  { label: '\\bibliographystyle', type: 'keyword', apply: '\\bibliographystyle{}' },

  // Graphics
  { label: '\\includegraphics', type: 'function', apply: '\\includegraphics[width=\\textwidth]{}' },
  { label: '\\graphicspath', type: 'function', apply: '\\graphicspath{{}}' },
  { label: '\\caption', type: 'function', apply: '\\caption{}' },
  { label: '\\centering', type: 'keyword' },

  // Math - common
  { label: '\\frac', type: 'function', detail: 'Fraction', apply: '\\frac{}{}' },
  { label: '\\sqrt', type: 'function', detail: 'Square root', apply: '\\sqrt{}' },
  { label: '\\sum', type: 'function', detail: 'Summation' },
  { label: '\\prod', type: 'function', detail: 'Product' },
  { label: '\\int', type: 'function', detail: 'Integral' },
  { label: '\\partial', type: 'function', detail: 'Partial derivative' },
  { label: '\\nabla', type: 'function', detail: 'Nabla/gradient' },
  { label: '\\infty', type: 'constant', detail: 'Infinity' },
  { label: '\\lim', type: 'function', detail: 'Limit' },
  { label: '\\log', type: 'function' },
  { label: '\\ln', type: 'function' },
  { label: '\\exp', type: 'function' },
  { label: '\\sin', type: 'function' },
  { label: '\\cos', type: 'function' },
  { label: '\\tan', type: 'function' },
  { label: '\\max', type: 'function' },
  { label: '\\min', type: 'function' },
  { label: '\\sup', type: 'function' },
  { label: '\\inf', type: 'function' },
  { label: '\\mathbb', type: 'function', detail: 'Blackboard bold', apply: '\\mathbb{}' },
  { label: '\\mathcal', type: 'function', detail: 'Calligraphic', apply: '\\mathcal{}' },
  { label: '\\mathbf', type: 'function', detail: 'Bold math', apply: '\\mathbf{}' },
  { label: '\\mathrm', type: 'function', detail: 'Roman math', apply: '\\mathrm{}' },
  { label: '\\text', type: 'function', detail: 'Text in math', apply: '\\text{}' },
  { label: '\\left', type: 'keyword' },
  { label: '\\right', type: 'keyword' },
  { label: '\\cdot', type: 'constant', detail: 'Center dot' },
  { label: '\\cdots', type: 'constant', detail: 'Center dots' },
  { label: '\\ldots', type: 'constant', detail: 'Lower dots' },
  { label: '\\dots', type: 'constant' },
  { label: '\\times', type: 'constant', detail: 'Times' },
  { label: '\\leq', type: 'constant', detail: 'Less than or equal' },
  { label: '\\geq', type: 'constant', detail: 'Greater than or equal' },
  { label: '\\neq', type: 'constant', detail: 'Not equal' },
  { label: '\\approx', type: 'constant', detail: 'Approximately' },
  { label: '\\equiv', type: 'constant', detail: 'Equivalent' },
  { label: '\\sim', type: 'constant', detail: 'Similar' },
  { label: '\\propto', type: 'constant', detail: 'Proportional to' },
  { label: '\\rightarrow', type: 'constant', detail: 'Right arrow' },
  { label: '\\leftarrow', type: 'constant', detail: 'Left arrow' },
  { label: '\\Rightarrow', type: 'constant', detail: 'Double right arrow' },
  { label: '\\Leftarrow', type: 'constant', detail: 'Double left arrow' },
  { label: '\\forall', type: 'constant', detail: 'For all' },
  { label: '\\exists', type: 'constant', detail: 'Exists' },
  { label: '\\in', type: 'constant', detail: 'Element of' },
  { label: '\\notin', type: 'constant', detail: 'Not element of' },
  { label: '\\subset', type: 'constant', detail: 'Subset' },
  { label: '\\subseteq', type: 'constant', detail: 'Subset or equal' },
  { label: '\\cup', type: 'constant', detail: 'Union' },
  { label: '\\cap', type: 'constant', detail: 'Intersection' },
  { label: '\\emptyset', type: 'constant', detail: 'Empty set' },
  { label: '\\pm', type: 'constant', detail: 'Plus-minus' },
  { label: '\\mp', type: 'constant', detail: 'Minus-plus' },
  { label: '\\hat', type: 'function', apply: '\\hat{}' },
  { label: '\\bar', type: 'function', apply: '\\bar{}' },
  { label: '\\tilde', type: 'function', apply: '\\tilde{}' },
  { label: '\\vec', type: 'function', apply: '\\vec{}' },
  { label: '\\dot', type: 'function', apply: '\\dot{}' },
  { label: '\\ddot', type: 'function', apply: '\\ddot{}' },
  { label: '\\overline', type: 'function', apply: '\\overline{}' },
  { label: '\\underline', type: 'function', apply: '\\underline{}' },
  { label: '\\overbrace', type: 'function', apply: '\\overbrace{}' },
  { label: '\\underbrace', type: 'function', apply: '\\underbrace{}' },

  // Greek letters
  { label: '\\alpha', type: 'constant', detail: 'Greek' },
  { label: '\\beta', type: 'constant', detail: 'Greek' },
  { label: '\\gamma', type: 'constant', detail: 'Greek' },
  { label: '\\delta', type: 'constant', detail: 'Greek' },
  { label: '\\epsilon', type: 'constant', detail: 'Greek' },
  { label: '\\varepsilon', type: 'constant', detail: 'Greek' },
  { label: '\\zeta', type: 'constant', detail: 'Greek' },
  { label: '\\eta', type: 'constant', detail: 'Greek' },
  { label: '\\theta', type: 'constant', detail: 'Greek' },
  { label: '\\iota', type: 'constant', detail: 'Greek' },
  { label: '\\kappa', type: 'constant', detail: 'Greek' },
  { label: '\\lambda', type: 'constant', detail: 'Greek' },
  { label: '\\mu', type: 'constant', detail: 'Greek' },
  { label: '\\nu', type: 'constant', detail: 'Greek' },
  { label: '\\xi', type: 'constant', detail: 'Greek' },
  { label: '\\pi', type: 'constant', detail: 'Greek' },
  { label: '\\rho', type: 'constant', detail: 'Greek' },
  { label: '\\sigma', type: 'constant', detail: 'Greek' },
  { label: '\\tau', type: 'constant', detail: 'Greek' },
  { label: '\\upsilon', type: 'constant', detail: 'Greek' },
  { label: '\\phi', type: 'constant', detail: 'Greek' },
  { label: '\\varphi', type: 'constant', detail: 'Greek' },
  { label: '\\chi', type: 'constant', detail: 'Greek' },
  { label: '\\psi', type: 'constant', detail: 'Greek' },
  { label: '\\omega', type: 'constant', detail: 'Greek' },
  { label: '\\Gamma', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Delta', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Theta', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Lambda', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Xi', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Pi', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Sigma', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Phi', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Psi', type: 'constant', detail: 'Greek uppercase' },
  { label: '\\Omega', type: 'constant', detail: 'Greek uppercase' },

  // Environments (begin/end snippets)
  { label: '\\begin{equation}', type: 'keyword', detail: 'Equation env', apply: '\\begin{equation}\n\t\n\\end{equation}' },
  { label: '\\begin{equation*}', type: 'keyword', detail: 'Unnumbered equation', apply: '\\begin{equation*}\n\t\n\\end{equation*}' },
  { label: '\\begin{align}', type: 'keyword', detail: 'Align env', apply: '\\begin{align}\n\t\n\\end{align}' },
  { label: '\\begin{align*}', type: 'keyword', detail: 'Unnumbered align', apply: '\\begin{align*}\n\t\n\\end{align*}' },
  { label: '\\begin{figure}', type: 'keyword', detail: 'Figure env', apply: '\\begin{figure}[htbp]\n\t\\centering\n\t\\includegraphics[width=\\textwidth]{}\n\t\\caption{}\n\t\\label{fig:}\n\\end{figure}' },
  { label: '\\begin{table}', type: 'keyword', detail: 'Table env', apply: '\\begin{table}[htbp]\n\t\\centering\n\t\\begin{tabular}{}\n\t\t\n\t\\end{tabular}\n\t\\caption{}\n\t\\label{tab:}\n\\end{table}' },
  { label: '\\begin{itemize}', type: 'keyword', detail: 'Bullet list', apply: '\\begin{itemize}\n\t\\item \n\\end{itemize}' },
  { label: '\\begin{enumerate}', type: 'keyword', detail: 'Numbered list', apply: '\\begin{enumerate}\n\t\\item \n\\end{enumerate}' },
  { label: '\\begin{description}', type: 'keyword', detail: 'Description list', apply: '\\begin{description}\n\t\\item[] \n\\end{description}' },
  { label: '\\begin{abstract}', type: 'keyword', detail: 'Abstract', apply: '\\begin{abstract}\n\t\n\\end{abstract}' },
  { label: '\\begin{verbatim}', type: 'keyword', detail: 'Verbatim', apply: '\\begin{verbatim}\n\t\n\\end{verbatim}' },
  { label: '\\begin{quote}', type: 'keyword', detail: 'Quote', apply: '\\begin{quote}\n\t\n\\end{quote}' },
  { label: '\\begin{center}', type: 'keyword', detail: 'Center', apply: '\\begin{center}\n\t\n\\end{center}' },
  { label: '\\begin{minipage}', type: 'keyword', detail: 'Minipage', apply: '\\begin{minipage}{\\textwidth}\n\t\n\\end{minipage}' },
  { label: '\\begin{tabular}', type: 'keyword', detail: 'Tabular', apply: '\\begin{tabular}{|c|c|c|}\n\t\\hline\n\t & & \\\\\n\t\\hline\n\\end{tabular}' },
  { label: '\\begin{array}', type: 'keyword', detail: 'Math array', apply: '\\begin{array}{}\n\t\n\\end{array}' },
  { label: '\\begin{pmatrix}', type: 'keyword', detail: 'Parenthesis matrix', apply: '\\begin{pmatrix}\n\t\n\\end{pmatrix}' },
  { label: '\\begin{bmatrix}', type: 'keyword', detail: 'Bracket matrix', apply: '\\begin{bmatrix}\n\t\n\\end{bmatrix}' },
  { label: '\\begin{cases}', type: 'keyword', detail: 'Cases', apply: '\\begin{cases}\n\t\n\\end{cases}' },
  { label: '\\begin{proof}', type: 'keyword', detail: 'Proof', apply: '\\begin{proof}\n\t\n\\end{proof}' },
  { label: '\\begin{theorem}', type: 'keyword', detail: 'Theorem', apply: '\\begin{theorem}\n\t\n\\end{theorem}' },
  { label: '\\begin{lemma}', type: 'keyword', detail: 'Lemma', apply: '\\begin{lemma}\n\t\n\\end{lemma}' },
  { label: '\\begin{document}', type: 'keyword', detail: 'Document', apply: '\\begin{document}\n\t\n\\end{document}' },
  { label: '\\item', type: 'keyword' },

  // Spacing and layout
  { label: '\\hspace', type: 'function', apply: '\\hspace{}' },
  { label: '\\vspace', type: 'function', apply: '\\vspace{}' },
  { label: '\\newline', type: 'keyword' },
  { label: '\\newpage', type: 'keyword' },
  { label: '\\clearpage', type: 'keyword' },
  { label: '\\noindent', type: 'keyword' },
  { label: '\\textwidth', type: 'constant' },
  { label: '\\linewidth', type: 'constant' },
  { label: '\\columnwidth', type: 'constant' },
  { label: '\\textheight', type: 'constant' },

  // Common packages
  { label: '\\usepackage{amsmath}', type: 'keyword', detail: 'Math extensions' },
  { label: '\\usepackage{amssymb}', type: 'keyword', detail: 'Math symbols' },
  { label: '\\usepackage{graphicx}', type: 'keyword', detail: 'Graphics' },
  { label: '\\usepackage{hyperref}', type: 'keyword', detail: 'Hyperlinks' },
  { label: '\\usepackage{geometry}', type: 'keyword', detail: 'Page geometry' },
  { label: '\\usepackage{booktabs}', type: 'keyword', detail: 'Better tables' },
  { label: '\\usepackage{natbib}', type: 'keyword', detail: 'Bibliography' },
  { label: '\\usepackage{biblatex}', type: 'keyword', detail: 'Bibliography' },
  { label: '\\usepackage{xcolor}', type: 'keyword', detail: 'Colors' },
  { label: '\\usepackage{listings}', type: 'keyword', detail: 'Code listings' },
  { label: '\\usepackage{tikz}', type: 'keyword', detail: 'TikZ graphics' },
  { label: '\\usepackage{algorithm2e}', type: 'keyword', detail: 'Algorithms' },
  { label: '\\usepackage{subcaption}', type: 'keyword', detail: 'Sub-figures' },
  { label: '\\usepackage{multirow}', type: 'keyword', detail: 'Multi-row tables' },
  { label: '\\usepackage{float}', type: 'keyword', detail: 'Float placement' },
  { label: '\\usepackage{enumitem}', type: 'keyword', detail: 'List customization' },
];

export function latexCompletionSource(context) {
  const word = context.matchBefore(/\\[a-zA-Z*{}]*/);
  if (!word || (word.from === word.to && !context.explicit)) return null;
  return {
    from: word.from,
    options: latexCommands,
    validFor: /^\\[a-zA-Z*{}]*$/,
  };
}
